import { Fetch } from '../helpers/fetchWrapper';
import useServiceQuery from '../hooks/useServiceQuery';

const userService = {
  user_url: process.env.REACT_APP_USER_API_URL,
  GetApiKeys(refetch) {
    const { data, loading, error } = useServiceQuery({
      name: 'user.apiKeys',
      params: null,
      queryFn: () => userService.getApiKey().then(res => res?.data?.apiKeys || []),
      refresh: refetch,
      persist: false,
    });
    return {
      apiKeys_loading: loading,
      apiKeys_error: error,
      apiKeys_data: data ?? [],
    };
  },

  async updateUser(payload) {
    let res = await Fetch.upload(`${this.user_url}/profile`, 'PUT', payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updatePassword(payload) {
    let res = await Fetch.patch(`${this.user_url}/update-password`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getToaster() {
    let res = await Fetch.get(`${this.user_url}/get-all-toasters`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async userOnboard(payload) {
    let res = await Fetch.post(`${this.user_url}/onboard-user`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getStripeConfig() {
    let res = await Fetch.get(`${this.user_url}/config`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async createPaymentIntent(payload) {
    let res = await Fetch.post(`${this.user_url}/create-payment-intent`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateTourCompletion(payload) {
    let res = await Fetch.patch(`${this.user_url}/update-tour-completion`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async generateApiKey(source) {
    let res = await Fetch.post(`${this.user_url}/api-keys`, { source });
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getApiKey() {
    let res = await Fetch.get(`${this.user_url}/api-keys`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getHoudinyLeadsCredits() {
    let res = await Fetch.get(`${this.user_url}/credits/leads_hub`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getGoogleCalendarAuthUrl() {
    let res = await Fetch.get(`${this.user_url}/google-calendar/connect`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async disconnectGoogleCalendar(selector = {}) {
    const connectedEmail = selector?.connectedEmail;

    if (!connectedEmail) {
      throw new Error('connectedEmail is required to disconnect Google Calendar');
    }

    const params = new URLSearchParams();
    params.set('connectedEmail', String(connectedEmail));
    const query = params.toString();

    let res = await Fetch.patch(`${this.user_url}/google-calendar/disconnect?${query}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async getGoogleCalendarAccounts() {
    let res = await Fetch.get(`${this.user_url}/google-calendar/accounts`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default userService;
